import React, { useState, useEffect } from "react";
import {
  ForgotPassword,
  logininfluencer,
  UpdatePassword,
  VerifyOtp,
} from "../../redux/actions/InfluencerAction";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

const Login = () => {
  const { addToast } = useToasts();
  const history = useHistory();
  const [number, setNumber] = useState("")
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [loder, setLoder] = useState(false);
  const [swap, setSwap] = useState(false);
  const [forgotPasswordForm, setForgotpasswordForm] = useState("");

  const user = JSON.parse(localStorage.getItem("INFLUENCER"));

  useEffect(() => {
    if (user) {
      history.push("/crm/dashboard");
    }
  }, [user]);

  const submitLogin = (e) => {
    e.preventDefault();
    var crmid="admin";
    var crmpass="123456";
    if (crmid==userId && crmpass==password){
        history.push("/crm/dashboard");
        localStorage.setItem("CRM","true")
        window.location.reload();
    }
    else{
        addToast("Enter valid ID and password")
    }
    
  };

  const forgot = (e) => {
    e.preventDefault();
    setLoder(true);
    const data = {
      phoneNumber: number,
    };
    const onSuccess = (msg) => {
      setLoder(false);
      addToast(msg, {
        appearance: "success",
        autoDismiss: true,
      });
      setForgotpasswordForm("verify");
    };
    const onError = (msg) => {
      setLoder(false);
      addToast(msg, {
        appearance: "error",
        autoDismiss: true,
      });
    };
    ForgotPassword(data, onSuccess, onError);
  };

  const verifyOtp = (e) => {
    e.preventDefault();
    setLoder(true);
    const data = {
      OTP: otp,
    };
    const onSuccess = (msg) => {
      setLoder(false);
      addToast(msg, {
        appearance: "success",
        autoDismiss: true,
      });
      setForgotpasswordForm("password");
    };
    const onError = (msg) => {
      setLoder(false);
      addToast(msg, {
        appearance: "error",
        autoDismiss: true,
      });
    };
    VerifyOtp(data, onSuccess, onError);
  };

  const updatepass = (e) => {
    e.preventDefault();
    setLoder(true);
    const data = {
      phoneNumber_: number,
      password_: password,
    };
    const onSuccess = (msg) => {
      setLoder(false);
      addToast(msg, {
        appearance: "success",
        autoDismiss: true,
      });
      history.push("/affiliate/dashboard");
      window.location.reload();
    };
    const onError = (msg) => {
      setLoder(false);
      addToast(msg, {
        appearance: "error",
        autoDismiss: true,
      });
    };
    UpdatePassword(data, onSuccess, onError);
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-inner">
        {!swap ? (
          <form onSubmit={(e) => submitLogin(e)}>
            <h3>Sign In</h3>

            <div className="form-group">
              <label>UserId</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter User Id"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                required
              />
            </div>

            <div className="form-group mt-3">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              disabled={loder ? true : false}
              className="btn btn-primary mt-3 btn-block"
            >
              {loder ? "Loading..." : "Submit"}
            </button>
            {/* <div
              className="d-flex flex-row-reverse"
              onClick={() => setSwap(true)}
            >
              <button type="button" className="btn btn-link">
                Forgot Password ?
              </button>
            </div> */}
          </form>
        ) : (
          <form
            onSubmit={
              forgotPasswordForm === "verify"
                ? (e) => verifyOtp(e)
                : forgotPasswordForm === "password"
                ? (e) => updatepass(e)
                : (e) => forgot(e)
            }
          >
            <h3>Forgot Password</h3>

            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter phone number"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                required
              />
            </div>

            {forgotPasswordForm === "verify" ? (
              <div className="form-group mt-3">
                <label>Varify your OTP</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter 6 digit OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </div>
            ) : (
              ""
            )}
            {forgotPasswordForm === "password" ? (
              <div className="form-group mt-3">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Reset password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            ) : (
              ""
            )}

            <button
              type="submit"
              disabled={loder ? true : false}
              className="btn btn-primary mt-3 btn-block"
            >
              {loder ? "Loading..." : "Submit"}
            </button>
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => setSwap(false)}
              >
                {"< "}Back
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default Login;